export enum SuccessStatusCode {
	Accepted = 202,
	Created = 201,
	NoContent = 204,
	Ok = 200
}

export enum ErrorOrFailStatusCode {
	BadGateway = 502,
	ServiceUnavailable = 503,
	BadRequest = 400,
	Conflict = 409,
	Forbidden = 403,
	Locked = 423,
	NotAcceptable = 406,
	NotFound = 404,
	RequestTimeout = 408,
	ServerError = 500,
	Unauthorized = 401,
	UnprocessableEntity = 422
}

export type HttpStatusCode = ErrorOrFailStatusCode | SuccessStatusCode;
